import { httpService } from '@services/httpService';
import { ApiRoute } from '@routes/apiRoutes';
import { useQuery, useMutation } from '@tanstack/react-query';
import { CompanyResponseModel } from '@models/login/companyResponseModel';
import { LoginResponseModel } from '@models/login/loginResponseModel';
import { QueryKeys } from '@enums/queryKeys';
import { LoginRequestModel } from '@models/login/loginRequestModel';
import { SwitchAccountRequestModel } from '@models/login/switchAccountRequestModel';
import { QueryCacheConstants } from '@constants/queryCacheConstants';

export const useFetchCompanyInfoApi = (companyId: string, options = {}) => {
  const login = async (companyId: string) => {
    return await httpService.get<CompanyResponseModel>(
      `${ApiRoute.CompanyInformation}?companyId=${companyId}`
    );
  };

  return useQuery({
    queryKey: [QueryKeys.COMPANY_INFO, companyId],
    queryFn: () => login(companyId),
    enabled: !!companyId,
    staleTime: QueryCacheConstants.DEFAULT_STALE_TIME,
    gcTime: QueryCacheConstants.DEFAULT_GC_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
  });
};

export const usePostLoginApi = () => {
  const login = async (loginRequest: LoginRequestModel) => {
    return await httpService.post<LoginResponseModel>(
      ApiRoute.Login,
      loginRequest
    );
  };

  return useMutation({
    mutationFn: (loginRequest: LoginRequestModel) => login(loginRequest),
  });
};

export const useSwitchAccountApi = () => {
  const switchAccount = async (loginRequest: SwitchAccountRequestModel) => {
    return await httpService.post<LoginResponseModel>(
      ApiRoute.SwitchAccount,
      loginRequest
    );
  };

  return useMutation({
    mutationFn: (loginRequest: SwitchAccountRequestModel) =>
      switchAccount(loginRequest),
  });
};
